import axios from "axios";

const API_BASE ="https://api.monappliclub.com";

const baseUrl = `${API_BASE}/api/subscriptions`;

export const getSubscriptionsByAssociation = async (associationId) => {
  const { data } = await axios.get(
    `${baseUrl}/subscriptionsByAssociation/${associationId}`
  );

  return data;
};